<template>
  <div id="login">
    <v-card raised elevation="24" shaped min-width="35%" max-height="100%">
      <h3 class="title text-center text-uppercase pt-5">Login</h3>
      <div class="pa-4">
        <v-text-field label="User ID" prepend-inner-icon="mdi-account" v-model="uid"></v-text-field>
        <v-text-field
          type="password"
          prepend-inner-icon="mdi-lock"
          label="Password"
          v-model="password"
        ></v-text-field>
      </div>
      <v-card-actions class="pb-10">
        <v-btn block color="primary1" rounded dark @click="login">LOGIN</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    uid: "",
    password: ""
  }),
  created() {
    if (this.$session.get("isLoggedIn")) {
      this.$router.replace("/DASHBOARD");
    }
    this.$store.commit("SET_LOADING", false);
  },
  methods: {
    ...mapActions(["LOGIN"]),
    login() {
      if (this.uid != "" && this.password != "") {
        this.$store.commit("SET_LOADING", true);
        this.LOGIN({ uid: this.uid, password: this.password }).then(() => {
          if (this.PATH != this.$route.path) {
            this.uid = "";
            this.password = "";
            this.$router.replace("/DASHBOARD");
          } else {
            this.$store.commit("SET_LOADING", false);
          }
        });
        // console.log(this.uid + " " + this.password);
      } else {
        this.$store.commit("SET_INFO", "Enter User ID and Password");
      }
      // this.$router.replace("/DASHBOARD");
    }
  },
  computed: {
    ...mapGetters(["PATH"])
  },
  watch: {},
  components: {}
};
</script>
<style scoped lang="scss">
#login {
  display: flex;
  width: 100vw;
  height: 80vh;
  justify-content: center;
  align-items: center;
}
</style>
